/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const contextmenu = () => {
  const menuitems = document.querySelectorAll('.js-context-menu-item');
  const tops = [];
  menuitems.forEach(element => {
    tops.push(
      document.querySelector(element.querySelector('a').getAttribute('href'))
        .offsetParent.offsetTop +
        document.querySelector(element.querySelector('a').getAttribute('href'))
          .offsetTop,
    );
  });
  function MouseWheelHandler(e) {
    const index = tops.findIndex(
      number => number > window.scrollY + window.innerHeight / 2,
    );
    let menuindex = 0;
    if (index - 1 === -1) {
      menuindex = 0;
    } else if (index - 1 === -2) {
      menuindex = tops.length - 1;
    } else {
      menuindex = index - 1;
    }
    menuitems.forEach(item => {
      item.classList.remove('is-active');
    });
    menuitems[menuindex].classList.add('is-active');
  }
  if (menuitems.length) {
    window.addEventListener('scroll', MouseWheelHandler, false);
  }
};

export default contextmenu;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/contextmenu.js